<template>
  <div class="ai-agent-collapse">
    <div class="ai-agent-collapse__header" @click="toggle">
      <div class="ai-agent-collapse__tabs">
        <div
          :class="[
            'ai-agent-collapse__tab',
            { selected: activeTab === 'summary' },
            { expanded: expanded },
          ]"
          v-if="summary"
          @click.stop="handleSelectTab('summary')"
        >
          <font-awesome-icon :icon="['fal', 'file-alt']" />
          {{ $t('mayday-web.ai-collapse.tabs.summary') }}
        </div>
        <div
          :class="[
            'ai-agent-collapse__tab',
            { selected: activeTab === 'action-items' },
            { expanded: expanded },
          ]"
          v-if="actionItems"
          @click.stop="handleSelectTab('action-items')"
        >
          <font-awesome-icon :icon="['fal', 'file-check']" />
          {{ $t('mayday-web.ai-collapse.tabs.action-items') }}
        </div>
      </div>
      <font-awesome-icon
        :icon="['fal', 'chevron-right']"
        :class="['ai-agent-collapse__chevron', { expanded: expanded }]"
      />
    </div>
    <div :class="['ai-agent-collapse__body', { expanded: expanded }]">
      <div
        class="ai-agent-collapse__summary"
        v-if="summary && activeTab === 'summary'"
      >
        {{ summary }}
      </div>
      <div
        class="ai-agent-collapse__action-items"
        v-if="activeTab === 'action-items'"
      >
        <div
          v-for="(actionItem, i) in actionItems.body"
          class="ai-agent-collapse__action-item"
          :key="i"
        >
          <input type="checkbox" :name="i" :id="i" />
          <label :for="i" class="ai-agent-collapse__action-item-label">
            {{ actionItem }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiAgentCollapse',
  props: {
    summary: {
      type: String,
      default: '',
    },
    actionItems: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    expanded: false,
    activeTab: 'summary',
  }),
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
    handleSelectTab(tab) {
      if (tab === this.activeTab) this.toggle();
      else {
        this.activeTab = tab;
        if (!this.expanded) this.expanded = true;
      }
    },
  },
  created() {
    if (this.summary) this.activeTab = 'summary';
    else if (this.actionItems) this.activeTab = 'action-items';
  },
};
</script>

<style scoped lang="scss">
.ai-agent-collapse {
  background-color: $grey-1-mayday;
  border-radius: 4px;
  overflow: hidden;
}

.ai-agent-collapse__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;

  .ai-agent-collapse__tabs {
    display: flex;
    align-items: center;
    gap: 8px;

    .ai-agent-collapse__tab {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 4px 16px;
      border-radius: 4px;
      gap: 8px;
      transition: all 0.2s ease-in-out;
      font-weight: bold;
      color: $purple-5-mayday;

      &.expanded {
        &.selected {
          background-color: $purple-5-mayday;
          color: white;
        }
      }

      &:hover {
        background-color: $purple-1-mayday;
      }
    }
  }

  .ai-agent-collapse__chevron {
    transition: all 0.2s ease-in-out;
    color: $purple-5-mayday;
    font-size: 14px;
    transform: rotate(0deg);

    &.expanded {
      transform: rotate(90deg);
    }
  }
}

.ai-agent-collapse__body {
  max-height: 0;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  padding-left: 12px;
  padding-right: 12px;

  &.expanded {
    max-height: 150px;
    overflow: auto;
  }

  .ai-agent-collapse__summary {
    padding-top: 0;
    padding-bottom: 8px;
    font-size: 14px;
  }
}

.ai-agent-collapse__action-items {
  .ai-agent-collapse__action-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    input {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: 1px solid $grey-3-mayday;
      background-color: white;
      cursor: pointer;
      accent-color: $purple-5-mayday;
      margin-top: 2px;
      flex: none;
    }

    label {
      cursor: pointer;
      font-size: 14px;
    }
  }
}
</style>
